import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as string | null;

const extractModalId = (payload: ModalData | null | string): string | null => {
  if (typeof payload === 'string') {
    return payload || initialState;
  }
  const { modalId } = payload || {};
  return modalId || initialState;
};

const slice = createSlice({
  name: 'currentModalId',
  initialState,
  reducers: {
    setCurrentModalId(state, action: PayloadAction<ModalData | null | string>) {
      return extractModalId(action.payload);
    },
  },
});

export const { setCurrentModalId } = slice.actions;

export default slice.reducer;
